import { useCallback, useState } from 'react';
import type { ConfigEntityDetail, EntityDetail } from '@web-config-app/core';

type SelectableEntity = ConfigEntityDetail | EntityDetail;

export const useEntityListTableSelectionState = (
  entityData: Array<SelectableEntity>,
) => {
  const [selectedEntities, setSelectedEntities] = useState<SelectableEntity[]>(
    [],
  );
  const getItemSelectionState = useCallback(
    (id: string) => selectedEntities.some((entity) => entity.id === id),
    [selectedEntities],
  );
  const handleEntitySelected = useCallback(
    (entity: SelectableEntity) => {
      const isSelected = selectedEntities.some((e) => e.id === entity.id);
      if (isSelected) {
        setSelectedEntities(selectedEntities.filter((e) => e.id !== entity.id));
      } else {
        setSelectedEntities([...selectedEntities, entity]);
      }
    },
    [selectedEntities],
  );
  const handleSelectAllChange = useCallback(
    (allSelected: boolean) => {
      setSelectedEntities(allSelected ? entityData : []);
    },
    [entityData],
  );
  const selectedCount = selectedEntities.length;
  const allSelected = selectedCount > 0 && selectedCount === entityData.length;
  const someSelected = selectedCount > 0 && !allSelected;

  return {
    getItemSelectionState,
    allSelected,
    someSelected,
    selectedCount,
    setSelectedEntities,
    handleEntitySelected,
    handleSelectAllChange,
    selectedEntities,
  };
};
